import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { OpenAPI } from "@/api";
import { routerBeforeEach } from "@/access";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";

router.beforeEach(routerBeforeEach);

const pinia = createPinia();
const app = createApp(App);

OpenAPI.WITH_CREDENTIALS = true;

app.use(Antd);
app.use(router);
app.use(pinia);

app.mount("#app");
